import { MarketplacePreviewStoresParams } from '../requests'
import { MarketplacePreviewItemsParams } from './useMarketplacePreviewItems'

export const MARKETPLACE_PREVIEW_QUERY_KEYS = {
  items: (params: MarketplacePreviewItemsParams) => [
    'marketplacePreviewItems',
    params,
  ],
  stores: (params: MarketplacePreviewStoresParams) => [
    'marketplacePreviewStores',
    params,
  ],
} as const
